var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var models;
    (function (models) {
        var CustomActionWorkflowBlock = /** @class */ (function (_super) {
            __extends(CustomActionWorkflowBlock, _super);
            function CustomActionWorkflowBlock(id, label) {
                var _this = _super.call(this, id, 5 /* CustomAction */, label) || this;
                _this.outerRadius = 85 / 2;
                _this.innerRadius = 50 / 2;
                _this.numberOfPoints = 5;
                _this.xPadding = (_this.blockWidth - (_this.outerRadius * 2)) / 2;
                _this.yPadding = (_this.blockHeight - (_this.outerRadius * 2)) / 2;
                _this.attributes = {
                    id: _this.id,
                    class: "action-workflow-block",
                    transform: 'r-18',
                    "data-class": "workflowBlock",
                    "data-id": "customAction"
                };
                return _this;
            }
            return CustomActionWorkflowBlock;
        }(models.SingleOutputWorkflowBlock));
        models.CustomActionWorkflowBlock = CustomActionWorkflowBlock;
    })(models = warsApp.models || (warsApp.models = {}));
})(warsApp || (warsApp = {}));
